import { SVGProps } from 'react'

const LaunchIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path d='M5.16699 4.66602H11.8337V11.3327' stroke='#959699' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M5.16699 11.3327L11.8337 4.66602'
                stroke='#959699'
                strokeWidth='1.40039'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default LaunchIcon
